export enum ButtonTier {
    FIRST = <any>"FIRST",
    SECOND = <any>"SECOND"
}

export enum ButtonProminence {
    HIGH = <any>"HIGH",
    LOW = <any>"LOW",
}

export enum ButtonConnotation {
    AFFIRMATIVE = <any>"AFFIRMATIVE",
    DISSUASIVE = <any>"DISSUASIVE",
    NEGATIVE = <any>"NEGATIVE"
}

export enum ButtonLayout {
    HORIZONTAL,
    VERTICAL
}



// WEBPACK FOOTER //
// ./src/app/buttons/button/button.ts